import { Directive, Input, } from '@angular/core';
import { Subject } from 'rxjs';
import { isPopoverMessage } from './models';
import { PopoverContentComponent } from './popover-content/popover-content.component';
import * as i0 from "@angular/core";
import * as i1 from "./popover.service";
export class PopoverDirective {
    constructor(element, popover, renderer, viewContainerRef) {
        this.element = element;
        this.popover = popover;
        this.renderer = renderer;
        this.viewContainerRef = viewContainerRef;
        this.config = {};
        this.target = this.element.nativeElement;
        /**
         * @deprecated use content object, template/component
         * exists for backwards compatiblity
         */
        this.popoverTitle = '';
        this.destroy$ = new Subject();
    }
    /**
     * @deprecated use config input `mhePopoverConfig`
     * exists for backwards compatiblity
     */
    set placement(val) {
        const { placement } = this.config;
        if (val && !placement) {
            this.config = Object.assign(Object.assign({}, this.config), { placement: val });
        }
    }
    /**
     * @deprecated use config input `mhePopoverConfig`
     * exists for backwards compatiblity
     */
    set panelClass(val) {
        const { panelClass } = this.config;
        if (val && !panelClass) {
            this.config = Object.assign(Object.assign({}, this.config), { panelClass: val });
        }
    }
    /** life cycle */
    ngOnInit() {
        this.on = this.on || ['click'];
    }
    ngAfterViewInit() {
        this.eventInit();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.listeners) === null || _a === void 0 ? void 0 : _a.forEach((unlisten) => unlisten());
        this.destroy$.next();
        this.destroy$.complete();
    }
    /** api */
    open() {
        const { content, target, config, viewContainerRef } = this;
        this.close();
        if (typeof content === 'string') {
            const popoverMessage = { content, title: this.popoverTitle };
            this.openSimpleContent(popoverMessage, target);
        }
        else if (isPopoverMessage(content)) {
            this.openSimpleContent(content, target);
        }
        else {
            this.ref = this.popover.open(content, target, config, viewContainerRef);
        }
    }
    close() {
        var _a;
        (_a = this.ref) === null || _a === void 0 ? void 0 : _a.close();
    }
    /**
     * @deprecated use explict open/close functions
     * exists for backwards compatiblity
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggle() { }
    /**
     * @deprecated use PopoverRef instance
     * exists for backwards compatiblity
     */
    isOpen() {
        return Boolean(this.ref);
    }
    /**
     * @deprecated use `close()` overlay destroyed in PopoverRef
     * exists for backwards compatiblity
     */
    destroyPopover() {
        this.close();
    }
    /** event handling */
    eventInit() {
        const { nativeElement } = this.element;
        const events = this.mapEvents(this.on);
        this.listeners = events.map((event) => this.renderer.listen(nativeElement, event, (_e) => this.open()));
    }
    mapEvents(events) {
        const isArray = Array.isArray(events);
        if (isArray) {
            return events;
        }
        events = this.mapCsv(events);
        return events;
    }
    mapCsv(events) {
        let arrEvents;
        if (events.indexOf(',') > -1) {
            const arr = events.split(',');
            arrEvents = arr.map((e) => e.trim());
        }
        else {
            arrEvents = [events];
        }
        return arrEvents;
    }
    /** content */
    openSimpleContent(message, target) {
        const { config } = this;
        this.ref = this.popover.open(PopoverContentComponent, target, Object.assign(Object.assign({}, config), { data: message }));
    }
}
PopoverDirective.ɵfac = function PopoverDirective_Factory(t) { return new (t || PopoverDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.PopoverService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ViewContainerRef)); };
PopoverDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: PopoverDirective, selectors: [["", "mhePopover", ""]], inputs: { content: ["mhePopover", "content"], config: ["mhePopoverConfig", "config"], target: ["mhePopoverTarget", "target"], on: ["mhePopoverOnEvent", "on"], popoverTitle: "popoverTitle", placement: "placement", panelClass: "panelClass", fullWidthElement: "fullWidthElement", width: "width", scrollableElement: "scrollableElement" }, exportAs: ["mhePopover"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverDirective, [{
        type: Directive,
        args: [{ selector: '[mhePopover]', exportAs: 'mhePopover' }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1.PopoverService }, { type: i0.Renderer2 }, { type: i0.ViewContainerRef }]; }, { content: [{
            type: Input,
            args: ['mhePopover']
        }], config: [{
            type: Input,
            args: ['mhePopoverConfig']
        }], target: [{
            type: Input,
            args: ['mhePopoverTarget']
        }], on: [{
            type: Input,
            args: ['mhePopoverOnEvent']
        }], popoverTitle: [{
            type: Input
        }], placement: [{
            type: Input
        }], panelClass: [{
            type: Input
        }], fullWidthElement: [{
            type: Input
        }], width: [{
            type: Input
        }], scrollableElement: [{
            type: Input
        }] }); })();
